import Resource from '@/api/resources/Resource'

class CommonPatientServices extends Resource {
    async getPatientInformation(laboratoryId, patId) {
        const response = await this.axios.get(`/common/patients/${patId}`, { params: { laboratoryId } })
        return response.data
    }

    async search(params) {
        const response = await this.axios.get('/common/patients/search', { params })
        return response.data
    }
}

export default new CommonPatientServices()
